import AboutBack from "./about-back.webp";
import Aunkere from "./Aunkere.webp";
import Bombbar from "./bombbar.webp";
import ByOwl from "./by_owl.webp";
import CaseEx from "./case-ex.webp";
import Ct0m from "./ct0m.webp";
import Dyrachyo from "./Dyrachyo.webp";
import FcsmKefir from "./fcsm_kefir.webp";
import FORZOREZOR from "./FORZOREZOR.webp";
import GoodWin from "./GoodWin.webp";
import Gr0mjkeee from "./gr0mjkeee.webp";
import ILTW from "./ILTW.webp";
import Iltw1 from "./iltw1.webp";
import KoryaMc from "./korya_mc.webp";
import Leva2k from "./leva2k.webp";
import MainBack from "./main-back.webp";
import Mood from "./mood.webp";
import MorpheYa from "./morphe_ya.webp";
import News1 from "./news-1.webp";
import News2 from "./news-2.webp";
import News3 from "./news-3.webp";
import News4 from "./news-4.webp";
import News5 from "./news-5.webp";
import Noize from "./noize.webp";
import Nuum from "./nuum.webp";
import Rostikfacekid from "./Rostikfacekid.webp";
import Shadowkekw from "./Shadowkekw.webp";
import Sorabi_ from "./Sorabi_.webp";
import Stray228 from "./Stray228.webp";
import Team from "./team.webp";
import TeammateEx from "./teammate-ex.webp";
import Testnews from "./testnews.webp";
import TpaBoMaH from "./TpaBoMaH.webp";
import Ybicanooobov from "./ybicanoooobov.webp";

const imges = {
    "about-back": AboutBack,
    "Aunkere": Aunkere,
    "bombbar": Bombbar,
    "by_owl": ByOwl,
    "case-ex": CaseEx,
    "ct0m": Ct0m,
    "Dyrachyo": Dyrachyo,
    "fcsm_kefir": FcsmKefir,
    "FORZOREZOR": FORZOREZOR,
    "GoodWin": GoodWin,
    "gr0mjkeee": Gr0mjkeee,
    "ILTW": ILTW,
    "iltw1": Iltw1,
    "korya_mc": KoryaMc,
    "leva2k": Leva2k,
    "main-back": MainBack,
    "mood": Mood,
    "morphe_ya": MorpheYa,
    "news-1": News1,
    "news-2": News2,
    "news-3": News3,
    "news-4": News4,
    "news-5": News5,
    "noize": Noize,
    "nuum": Nuum,
    "Rostikfacekid": Rostikfacekid,
    "Shadowkekw": Shadowkekw,
    "Sorabi_": Sorabi_,
    "Stray228": Stray228,
    "team": Team,
    "teammate-ex": TeammateEx,
    "testnews": Testnews,
    "TpaBoMaH": TpaBoMaH,
    "ybicanooobov": Ybicanooobov,
};

export default imges;
